export class ExitPropertyPageMessage {}